"use client"
import React from 'react';
import { motion } from 'framer-motion';
import { Project } from '@/data/projects';
import { fadeInUp, staggerContainer, scaleOnHover } from '../animations';

interface ProjectTeamProps {
  project: Project;
}

export const ProjectTeam: React.FC<ProjectTeamProps> = ({ project }) => {
  if (!project.team) return null;

  return (
    <motion.div {...fadeInUp} className="mb-16">
      <h2 className="text-2xl font-bold text-white mb-6">Team & Role</h2>
      <motion.div
        className="bg-white/5 p-6 rounded-lg"
        whileHover={scaleOnHover.hover}
        transition={scaleOnHover.transition}
      >
        <div className="grid md:grid-cols-2 gap-6">
          <div>
            <h3 className="text-xl font-semibold text-white mb-4">Team Information</h3>
            <p className="text-gray-300 mb-2">Team Size: {project.team.size}</p>
            <p className="text-gray-300">Role: {project.team.role}</p>
          </div>
          <div>
            <h3 className="text-xl font-semibold text-white mb-4">Responsibilities</h3>
            <motion.ul
              className="list-disc list-inside text-gray-300 space-y-1"
              variants={staggerContainer}
              initial="initial"
              animate="animate"
            >
              {project.team.responsibilities.map((responsibility, index) => (
                <motion.li
                  key={index}
                  variants={fadeInUp}
                >
                  {responsibility}
                </motion.li>
              ))}
            </motion.ul>
          </div>
        </div>
      </motion.div>
    </motion.div>
  );
}; 